import { Model } from '@/model/Model'
import { BaseParentState } from '@stateMachine/BaseParentState'
import { IStateMachine } from '@stateMachine/IStateMachine'
import { GameStatesEnum } from '../GameStatesEnum'
import { CascadeSpinState } from '@/states/cascade/CascadeSpinState'
import { RegularWinningsState } from '@/states/winings/RegularWinningsState'

export class CascadeState extends BaseParentState {
    public constructor(stateMachine: IStateMachine, model: Model, id: string) {
        super(stateMachine, model, id)

        // cascade flow
        this.addChild(RegularWinningsState, GameStatesEnum.REGULAR_WINNINGS_STATE)
        this.addChild(CascadeSpinState, GameStatesEnum.CASCADE_SPIN_STATE)
    }

    public begin() {
        this._activeIndex = 0
        this.beginChild()
    }

    public end = () => {
        if (!this._model.spinData.winning_combinations) {
            this._stateMachine.setState(GameStatesEnum.FINAL_STATE)
            return
        }

        const currentCombinations = this._model.spinData.winning_combinations[this._model.cascadeIndex] || []

        if (currentCombinations.length) {
            this._stateMachine.setState(GameStatesEnum.CASCADE_STATE)
            return
        }

        if (this._model.bigWinLevel !== null) {
            this._stateMachine.setState(GameStatesEnum.FINAL_STATE)
            return
        }

        this._stateMachine.setState(GameStatesEnum.FINAL_STATE)
    }
}
